import { useTranslation } from '@gimlite/common';
import { observer } from 'mobx-react-lite';
import { Button } from '../components/button/button.component';
import { Col } from '../components/col/col.component';
import { Icon } from '../components/icon/icon.component';
import { Write } from '../components/write/write.component';
import { useStoreUIV1 } from '../hooks/useStore.hook';
import React from 'react';
import { Row } from '../components/row/row.component';

export const Page401 = observer(() => {
  const { SSOStore } = useStoreUIV1();
  const { t } = useTranslation();
  const parentUrlExist =
    SSOStore.mode?.type === 'children' && SSOStore.mode?.parentUrl;

  const parentUrl =
    SSOStore.mode?.type === 'children' ? SSOStore.mode.parentUrl : null;

  return (
    <Row
      config={{
        height: 'full',
        horizontal: 'center',
        vertical: 'center',
      }}
    >
      <Col
        config={{
          height: 'initial',
          horizontal: 'center',
          vertical: 'center',
          gap: 16,
        }}
      >
        <Col
          config={{
            horizontal: 'center',
            vertical: 'center',
            height: 'initial',
            gap: 8,
          }}
        >
          <Write
            data={{ item: t('watermelon-401_TITLE') }}
            config={{ mode: 'title-medium' }}
          />
          <Write
            data={{ item: t('watermelon-401_DESCRIPTION') }}
            config={{ mode: 'value-small' }}
          />
        </Col>

        {parentUrlExist && (
          <Button
            config={{
              mode: 'fill',
              size: 'large',
              text: t('watermelon-backToDashboard'),
            }}
            handleEvent={{
              click: () => {
                if (parentUrl) {
                  window.location.href = parentUrl;
                }
              },
            }}
          ></Button>
        )}
      </Col>
    </Row>
  );
});
